module.exports = __webpack_public_path__ + "videos/optimised/7620c521128ff6b4dfbea82cf256f61b.mp4";